import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class ListSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'list');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.backgroundColorField('background.color', ['content']),
            this.backgroundColorField('alternate.background.color', ['list', 'content']),
            this.borderColorField('border.color', ['main', 'content']),
            this.fontColorComboField('icon.color', ['list', 'main', 'content'], {
                ...this.preset('icon-color', 'main'),
                ...this.shadeValues('lighten', 'list', 'background'),
                ...this.shadeValues('darken', 'list', 'background'),
                [this.translateValue('INHERIT')]: 'inherit',
            }),
            this.fontColorComboField('muted.color', ['list', 'main', 'content'], {
                ...this.shadeValues('fade', 'list', 'font', [0.2, 0.35, 0.5, 0.65]),
                ...this.shadeValues('fade', 'main', 'font', [0.2, 0.35, 0.5, 0.65]),
                ...this.preset('muted-color', 'main'),
            }),

            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.backgroundColorField('active.background.color', ['list', 'content'], this.preset('active-background-color', 'main')),
            this.sizeNumberField('active.border.radius', 'px'),
            this.sizeNumberField('active.margin.x'),
            this.fontColorComboField('hover.font.color', ['main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['list', 'content'], this.preset('hover-background-color', 'main')),
            
        ];
    }

}
